import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button , Dropdown , DropdownToggle, 
  DropdownMenu, DropdownItem
} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";
import IconEdit from 'react-icons/lib/md/edit';
import IconPersonAdd from 'react-icons/lib/md/person-add';
import IconForms from 'react-icons/lib/fa/wpforms';
import IconBan from "react-icons/lib/fa/ban";

import * as actions from '../../actions/movimientocompra';
import Modal from "./Modal";
import _ from "lodash";
import {API_URL,api} from '../../actions/_request';

import Menu from '../facturacion/menu.js';
import swal from 'sweetalert2';

const requestData = (pageSize, page, sorted, filtered) => {    
    return new Promise((resolve, reject) => {
        // You can retrieve your data however you want, in this case, we will just use some local data.
        let filteredData ;
        var fecha="";
        var factura="";
        var concepto="";
        var referencia="";
        var proveedor="";
        var take= pageSize;
        var skip=pageSize * page;
        var total=1;  
        for (var i = filtered.length - 1; i >= 0; i--) {
          switch(filtered[i].id)
          {
            case "fecha":
              fecha=filtered[i].value;
              break;
            case "factura":
              factura=filtered[i].value;
              break;            
            case "referencia":
              referencia=filtered[i].value;
              break;
            case "concepto":
              concepto=filtered[i].value;
              break;   
             case "proveedor":
              proveedor=filtered[i].value;
              break;           
          }
        }
        api().get(`/compra2/conteo?referencia=${referencia}&fecha=${fecha}&factura=${factura}&concepto=${concepto}&proveedor=${proveedor}&take=${take}&skip=${skip}`)
        .then(function(response)
        {
            if(response.status === 200)
            {
              total= response.data[0].total; 
              api().get(`/compra2/busqueda?referencia=${referencia}&fecha=${fecha}&factura=${factura}&concepto=${concepto}&proveedor=${proveedor}&take=${take}&skip=${skip}`)
              .then(function(response)
              {
                if(response.status === 200)
                {
                  filteredData= response.data; 
                  // You can also use the sorting in your request, but again, you are responsible for applying it.
                  const sortedData = _.orderBy(
                    filteredData,
                    sorted.map(sort => {
                      return row => {
                        if (row[sort.id] === null || row[sort.id] === undefined) {
                          return -Infinity;
                        }
                        return typeof row[sort.id] === "string"
                        ? row[sort.id].toLowerCase()
                        : row[sort.id];
                      };
                    }),
                    sorted.map(d => (d.desc ? "desc" : "asc"))
                  );
                  const res = {
                    rows: sortedData,
                    pages: Math.ceil(total / pageSize)
                  };
                  // Here we'll simulate a server response with 500ms of delay.
                  //setTimeout(() => resolve(res), 1000);
                  //console.log(res);
                  resolve(res)
                }
              });   
            }
        });
    });
};
class Embarques extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            modal       : false,
            prospectoid : null,
            title       : "Factura de Compra",
            data: [],
            pages: null,
            loading: true,
        };
        this.toggle 			= this.toggle.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.handleChangecheckbox       = this.handleChangecheckbox.bind(this);
        this.toggle_drop       = this.toggle_drop.bind(this);
        this.consulta1  = this.consulta1.bind(this);
        this.cancelar  = this.cancelar.bind(this);
    }
    cancelar(evt, compra){
      console.log('compra------>',compra)
      let self = this;
      swal.queue([{
        title: 'Estas seguro?',
        text: "Se Cacelara la compra "+compra.factura+" para "+compra.proveedor+' Por la cantidad de '+compra.total,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return api().get('/compra/cancelar/'+compra.value)
            .then(function(response)
            {    
                // console.log('response-->',response)    
                if(response.status === 200)
                {
                  // console.log('entor al status 200');
                  // console.log('compra-->',response.data.compra) ;
                  if(parseInt(response.data.estado)==200){
                     self.props.actualizar_renglon(response.data.compra);
                  }
                   if(parseInt(response.data.estado)==210){
                     swal.insertQueueStep({
                      type: 'error',
                      title: 'La Compra Cuenta Con Abonos'
                    })
                  }
                  if(parseInt(response.data.estado)==500){
                    console.log('Mensaje de error--->',response.data.error.descripcion)
                    swal.insertQueueStep({
                        type: 'error',
                        title: response.data.error.descripcion
                      })

                   }
                 
                }
            })
            .catch(() => {
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administrador',
              })
            })
        }
      }])
    }
    get_cliente(cliente = null){
    
    
          
  
  }
 fetchData(state, instance) {
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered
    ).then(res => {
      // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
      this.setState({
        data: res.rows,
        pages: res.pages,
        loading: false
      });
      this.props.get(res.rows);
    });
  }

  toggle_drop(menu,id) {
    let valor=0;

    if(menu===1){
      if(parseInt(this.state.menu)!==id)
        valor=id;
        this.setState({
          menu: valor
        });
    }else{
      if(parseInt(this.state.submenu)!==id)
        valor=id;
        this.setState({
          submenu: valor
        });
    }
  }

  handleChangecheckbox(row)
  {
    let bandera=0;
    this.setState({
      seleccion_id : parseInt( row.original.value),
      seleccion_label : row.original.label,
    });  
  }

  consulta1(evt){

    evt.preventDefault();
    window.open(`${API_URL}/abonosCompra/${this.state.seleccion_id}`)
  }

   toggle(evt, prospectoid = null, title = "Nueva Factura de Compra")
    {
        let {modal} = this.state;

        this.setState({
            modal       : !modal,
            prospectoid : prospectoid,
            title       : title,
            
        });
    }

    componentDidMount() {

       // this.props.get();
    }

    render() {
 const { data, pages, loading } = this.state;
        return(
            <div className="view">
            <Menu props={this.props}/>

                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Lista de Facturas de Compras</h1>
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                        <div className="row">
                          <div className="col text-left">
                            <Dropdown nav className='btn-sm info' color="" isOpen={parseInt(this.state.menu)===1?true:false} toggle={() => {this.toggle_drop(1,1);}} >
                              <DropdownToggle nav caret>
                               <IconForms/>Consultas
                              </DropdownToggle>
                              <DropdownMenu className='letras_menu'>
                                <DropdownItem onClick={this.consulta1}>Cargos / Abonos</DropdownItem>
                              </DropdownMenu>
                            </Dropdown>
                          </div>
                          <div className="col text-right">
                            <Button color="success" className="mb-2" onClick={this.toggle}>
                                <IconPersonAdd />&nbsp;Agregar
                            </Button>
                          </div>
                        </div>
                            <ReactTable
                              getTrProps={(state, rowInfo, column) => {
                                  
                                  if(rowInfo === undefined){
                                          
                                          return{

                                          }
                                        }else{
                                           return{
                                            onDoubleClick: (evt)=>this.toggle(evt, rowInfo.original.value, 'Editar Factura de Compra')
                                        } 
                                  
                                    }
                              }}
                             
                              className = "-striped -highlight"
                              columns   = {[
                                {
                                    Header: 'Seleccion',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:80,
                                    minWidth:80, 
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-center">
                                                <input type="checkbox"
                                                name="" 
                                                checked={(this.state.seleccion_id === parseInt( row.original.value)) ? true : false}
                                                onChange={() => this.handleChangecheckbox(row)}/>                                                 
                                            </div>
                                        )
                                    }
                                },
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:80,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-center">
                                                <Button
                                                 color="success" 
                                                 className="btn-sm" 
                                                 onClick={(evt)=>this.toggle(evt, row.original.value, 'Editar Factura de Compra')}>
                                                    <IconEdit />
                                                </Button>{' '}
                                                {
                                              (parseInt(row.original.cancelado)==0)&&
                                              <Button
                                                 color="warning" 
                                                 title=" Cancelar "
                                                 className="btn-sm" 
                                                 onClick={(evt)=>this.cancelar(evt, row.original)}>
                                                    <IconBan />
                                                </Button>
                                            }
                                                 
                                            </div>
                                        )
                                    }
                                },
                                {Header: 'Estado', accessor: 'estado',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Fecha', accessor: 'fecha',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Factura', accessor: 'factura',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Concepto', accessor: 'concepto' ,minWidth:300, style: { 'textAlign': 'center'}},
                                {Header: 'Proveedor', accessor: 'proveedor' ,minWidth:300, style: { 'textAlign': 'center'}}, 
                                {Header: 'Total', accessor: 'total',maxWidth:150,minWidth:150 , filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                                {Header: 'Saldo', accessor: 'saldo',maxWidth:150,minWidth:150 , filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                                
                                
                                
                              
                              ]}
                            
                              manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                              data={this.props.movimientocompra.data}
                              pages={pages} // Display the total number of pages
                              loading={loading} // Display the loading overlay when we need it
                              onFetchData={_.debounce(this.fetchData, 500)} // Request new data when things change
                              filterable
                              defaultPageSize={10}
                             
                              
                             
                            />
                        </CardBlock>
                    </Card>
                </div>
                {
                   this.state.modal&& 
                   <Modal 
                 open={this.state.modal} 
                 toggle={this.toggle} 
                 title={this.state.title} 
                 prospectoid={this.state.prospectoid}
                 get_cliente={this.get_cliente}
                />
                }
                 

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        movimientocompra : state.movimientocompra,
    }
};

export default connect(mapStateToProps, actions)(Embarques)


// WEBPACK FOOTER //
// ./src/views/movimientoscompras/index.js